module.exports = __webpack_public_path__ + "static/media/peo_everyone.53c97b1d.png";